import { textTransformToCapital } from '@umu/umu-util';
import { lang } from '@umu/ukit-lang';
import { ITemplateQuestionInfo, QuestionOperateType, QuestionType } from '../../interface/multiCapabilityTemplate';
const operateList = [
    {
        key: QuestionOperateType.MOVE,
        label: textTransformToCapital(lang('移动')),
    },
    {
        key: QuestionOperateType.COPY,
        label: lang('复制'),
    },
    {
        key: QuestionOperateType.DELETE,
        label: lang('删除'),
    },
];

const internalList = [
    {
        key: QuestionOperateType.UPDATE_IMG,
        iconType: 'Uploadimages',
        className: 'question-img',
        isUploadFile: true,
        accept: 'image/png,image/gif,image/jpg,image/jpeg',
        label: lang('上传图片'),
    },
];

const onUpdateQuestionListIndex = (list: ITemplateQuestionInfo[]) => {
    let tmpIndex = 0;
    return (list || []).map((item) => {
        const isNotAddIndex = [QuestionType.PARAGRAPH].includes(item.type);
        tmpIndex = isNotAddIndex ? tmpIndex : tmpIndex + 1;
        return {
            ...item,
            index: tmpIndex,
        };
    });
};
export { operateList, internalList, onUpdateQuestionListIndex };
